import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 99C269BA-B1CD-4BC0-9BCC-7C5D95F881AC
 * name view-carousel
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/view-carousel.svg
 * tags
 * - View 
 */
export const ViewCarouselIcon = createSvgIcon(<><path d="M18,6V17H22V6M2,17H6V6H2M7,19H17V4H7V19Z" /></>, 'ViewCarouselIcon');
export default ViewCarouselIcon